import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ReadMore extends ThemeComponent {
    @Ref() truncatedText!: HTMLElement;
    @Ref() fullText!: HTMLElement;
    @Ref() readMore!: HTMLElement;

    init() {

        // Hide full text
        this.fullText.classList.add('visually-hidden');

        // Listen for read more click
        this.$listen(this.readMore, 'click', () => {

            // Show full text
            this.fullText.classList.remove('visually-hidden');

            // Hide truncated text
            this.truncatedText.classList.add('visually-hidden');

            // Remove read more button
            this.readMore.remove();
        });
    }
}
